import React, { useState } from 'react';
import { MultiSelectInput } from "../MultiSelectInput/MultiSelectInput.js";
import { MultiSelectMobileModal } from "../MultiSelectMobileModal/MultiSelectMobileModal.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const MultiSelectMobile = ({
  children,
  className,
  activeItems,
  inputValue,
  submitButtonCaption,
  setActiveItems,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    if (!props.disabled) {
      setOpen(true);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [open && /*#__PURE__*/_jsx(MultiSelectMobileModal, {
      submitButtonCaption: submitButtonCaption,
      onClose: () => setOpen(false),
      label: props.label,
      id: props.id,
      onSubmit: items => {
        setActiveItems(items);
        setOpen(false);
      },
      activeItems: activeItems,
      children: children
    }), /*#__PURE__*/_jsx(MultiSelectInput, {
      ...props,
      onClick: handleClick,
      value: inputValue
    })]
  });
};